import {
  GET_PURCHASING_MECHANISMS,
  GET_PURCHASING_MECHANISMS_ERROR,
  GET_PURCHASING_MECHANISMS_SUCCESS
} from './ContingenciesPurchasingMechanismsSection.actions'

const contingenciesPurchasingMechanismsState = {
  categories: [],
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The contingenciesPurchasingMechanismsReducer's reducer.
 */
const contingenciesPurchasingMechanismsReducer = (
  state = contingenciesPurchasingMechanismsState,
  { payload, type }
) => {
  switch (type) {
    case GET_PURCHASING_MECHANISMS: {
      return { ...state, loading: true }
    }
    case GET_PURCHASING_MECHANISMS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PURCHASING_MECHANISMS_SUCCESS: {
      return { ...state, categories: payload.categories, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesPurchasingMechanismsReducer
